export let VIDEO_PLAYBACK_STATUSES;
(function (VIDEO_PLAYBACK_STATUSES) {
  VIDEO_PLAYBACK_STATUSES["INITIAL"] = "initial";
  VIDEO_PLAYBACK_STATUSES["PLAY_REQUESTED"] = "play-requested";
  VIDEO_PLAYBACK_STATUSES["PLAY_ABORTED"] = "play-aborted";
  VIDEO_PLAYBACK_STATUSES["PLAYING"] = "playing";
  VIDEO_PLAYBACK_STATUSES["PAUSE_REQUESTED"] = "pause-requested";
  VIDEO_PLAYBACK_STATUSES["PAUSED"] = "paused";
  VIDEO_PLAYBACK_STATUSES["ENDED"] = "ended";
})(VIDEO_PLAYBACK_STATUSES || (VIDEO_PLAYBACK_STATUSES = {}));
//# sourceMappingURL=video-playback-statuses.js.map